import { useCallback } from "react";

import type { VoucherInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import * as Shared from "../../../../../../_shared";
import * as Schema from "../schema";

export const useVoucherCreate = () => {
	const { mutationFunc } = useCustomMutation(Schema.VoucherCreate_EditPage_Mutation);

	const onVoucherCreate = useCallback(
		async (input: VoucherInput) =>
			await mutationFunc({
				variables: {
					input,
				},
				refetchQueries: [
					{
						query: Shared.Repository.Query.Schema.VoucherListByHotelID_TopPage_Query,
						variables: {
							hotelID: input.hotelID,
						},
					},
				],
			}),
		[mutationFunc],
	);

	return { onVoucherCreate };
};
